// Component: Toggle.jsx
// Purpose: DS switch — `.ds-toggle` track + knob, accent when on. Controlled
//   (checked / onChange). Renders as a role="switch" button for a11y.

import React from "react";
import { cx } from "./cx";

export function Toggle({ checked = false, onChange, label, disabled, className, ...props }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onChange?.(!checked)}
      className={cx("ds-toggle", className)}
      {...props}
    >
      <span className={cx("ds-toggle-track", checked && "on")} />
      {label != null && <span className="ds-toggle-label">{label}</span>}
    </button>
  );
}

export default Toggle;
